const ReSignActionType = {
  STORE_CUSTOMER_INFO: 'RESIGN_STORE_CUSTOMER_INFO',
  STORE_RESIGN_RESPONSE: 'RESIGN_STORE_RESIGN_RESPONSE'
};

export default ReSignActionType;



/** WEBPACK FOOTER **
 ** ./src/common/ResignActionType.js
 **/